import { gql } from '@apollo/client'

export const MEETING_REQUEST_OPTIONS = gql`
  query meetingRequestOptions($employeeId: HashedId!) {
    meetingRequestOptionsForEmployee(employeeId: $employeeId) {
      possible
      tagAssignmentIsInProgress
      isAppraisalEnabled
    }
  }
`
